import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentAnonModule } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import ThreadBuilder from './ThreadBuilder';

const AnonModuleView = ({ disabled }: { disabled: boolean }) => {
  const anonModule = useSelector(selectCurrentAnonModule);

  const [moduleIndex, modifierIndex] = useSelector((state: any) => [
    state.threadUi.moduleIndex,
    state.threadUi.modifierIndex,
  ]);

  const baseAttr = `[${moduleIndex}].modifierValues[${modifierIndex}].controlValues.rule.then.anonymousModule`;

  const options = [anonModule];

  if (!anonModule) {
    return null;
  }

  return (
    <ThreadBuilder
      attr={baseAttr}
      disabled={disabled}
      isAnon
      key={anonModule.id}
      modules={options}
      showAddModuleButton={false}
    ></ThreadBuilder>
  );
};

export default AnonModuleView;
